import { useEffect } from 'react'
import { blackDiamondWPSettingsDefaultValues, type BlackDiamondWPSettingsFormValues } from './model'
import { Controller, useForm } from 'react-hook-form'
import { Col, Container, Form, Row, Stack } from 'react-bootstrap'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { FormFeedback } from '../../../../../components/Form/FormFeedback'
import { Button } from '../../../../../components/Button/Button'
import { useBlackDiamondWPContactSync } from './hooks'

export const BlackDiamondWPContactSyncSettings = () => {
  const { checkpoint, isGetCheckpointFetching, isFetching, isSaving, save } = useBlackDiamondWPContactSync()

  const form = useForm<BlackDiamondWPSettingsFormValues>({ defaultValues: blackDiamondWPSettingsDefaultValues })

  useEffect(() => {
    if (isGetCheckpointFetching || !checkpoint) {
      return
    }
    form.setValue('inbound.contact.autoSync', checkpoint.data?.active || false)
  }, [isGetCheckpointFetching, checkpoint, form])

  const onSubmit = async (data: BlackDiamondWPSettingsFormValues) => {
    await save(data)
  }

  const handleCancel = () => {
    form.reset()
  }

  if (isFetching) {
    return (
      <Container>
        <div className='skeleton mb-2' style={{ width: '100%', height: '70px' }} />
        <div className='skeleton mb-3' style={{ width: '100%', height: '70px' }} />
      </Container>
    )
  }

  return (
    <Container>
      <h6>Contacts</h6>
      <div>Keep your contacts in sync between Zocks and SS&amp;C BlackDiamond Wealth Platform.</div>
      <Row className='mb-1 mt-3'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div>Synchronize your contacts automatically</div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <Controller
              name='inbound.contact.autoSync'
              control={form.control}
              render={({ field, fieldState }) => (
                <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
                  <Form.Switch checked={field.value === true} onChange={field.onChange} disabled={isGetCheckpointFetching} />
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </ScopedBlock>
              )}
            />
          </Stack>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <div className='d-flex gap-3 justify-content-end mb-4'>
            <Button variant='secondary' onClick={handleCancel} disabled={isSaving}>
              Reset
            </Button>
            <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
              <Button variant='primary' onClick={form.handleSubmit(onSubmit)} loading={isSaving}>
                Save
              </Button>
            </ScopedBlock>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
